export default "__VITE_ASSET__xsvTGuwD__"